// extracted by mini-css-extract-plugin
export default {"container":"TopHeader_container__jsmEi","close":"TopHeader_close__L4M7W","logo":"TopHeader_logo__DmkLK","text1":"TopHeader_text1__rl8ch","subText":"TopHeader_subText__n40fn"};